__turbopack_context__.v({
  "centerdItem": "WhyAmity-module-scss-module__vLl4jW__centerdItem",
  "img": "WhyAmity-module-scss-module__vLl4jW__img",
  "intersectionDiv": "WhyAmity-module-scss-module__vLl4jW__intersectionDiv",
  "item": "WhyAmity-module-scss-module__vLl4jW__item",
  "referralTitle": "WhyAmity-module-scss-module__vLl4jW__referralTitle",
  "subtitle": "WhyAmity-module-scss-module__vLl4jW__subtitle",
  "title": "WhyAmity-module-scss-module__vLl4jW__title",
  "wrapperIntersection": "WhyAmity-module-scss-module__vLl4jW__wrapperIntersection",
});
